import type { IncomingMessage, ServerResponse } from 'node:http';
import type { PreviewServer, ViteDevServer } from 'vite';
import { Readable } from 'node:stream';
import type { Response as MiniflareResponse } from 'miniflare';
import { Request as MiniflareRequest } from 'miniflare';

export function toWeb(req: IncomingMessage) {
  return new MiniflareRequest(toURL(req), {
    method: req.method,
    headers: { ...(req.headers as Record<string, string>) },
    body: req.headers['content-length'] ? Readable.toWeb(req) : undefined,
    duplex: 'half',
    redirect: 'manual',
  });
}

export function pipeFromWeb(
  miniflareResponse: MiniflareResponse,
  res: ServerResponse
) {
  const headers = Object.fromEntries(miniflareResponse.headers.entries());

  const setCookieHeader = 'set-cookie';
  if (headers[setCookieHeader]) {
    delete headers[setCookieHeader];
    res.setHeader(setCookieHeader, miniflareResponse.headers.getSetCookie());
  }

  res.writeHead(
    miniflareResponse.status,
    miniflareResponse.statusText,
    headers
  );

  if (miniflareResponse.body) {
    Readable.fromWeb(miniflareResponse.body).pipe(res);
  } else {
    res.end();
  }
}

export function toURL(req: IncomingMessage) {
  const pathname = req.url ?? '/';

  return new URL(
    pathname,
    (req.headers.host && `http://${req.headers.host}`) ?? 'http://wix.com'
  );
}

export function getViteServerUrl(
  viteServer: ViteDevServer | PreviewServer
): string {
  const viteAddress = viteServer.resolvedUrls?.local[0];

  if (!viteAddress) {
    throw new Error('Vite server listening but no URL.');
  }

  return viteAddress;
}
